import { switchMap, take } from 'rxjs';
import { HttpInterceptorFn } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { GlobalState } from '../store/global/global.state';
import { selectCurrentOrganizationId } from '../store/global/global.selectors';
import { inject } from '@angular/core';

export const organizationInterceptor: HttpInterceptorFn = (req, next) => {
    // TODO: seems like this class is overshadowed by apollo-link.provider.ts
    // this is due to interceptors not working with GraphQL batches
    // consider future of this class
    const store = inject<Store<GlobalState>>(Store);

    return store.select(selectCurrentOrganizationId).pipe(
        take(1),
        switchMap((organizationId) => {
            if (!organizationId) {
                return next(req);
            }

            const modifiedRequest = req.clone({
                headers: req.headers.set('selectedOrganizationId', organizationId?.toString() || ''),
            });

            return next(modifiedRequest);
        }),
    );
};
